<template>
  <el-form-item label="手机号" prop="phone" :error="error">
    <el-input
      v-model="valueBackUp"
      @input="handleChange"
      :disabled="isSearching"
      maxlength="11"
      show-word-limit
      clearable
      placeholder="请输入手机号"
    />
  </el-form-item>
</template>

<script>
import { getIdByPhone } from '@/api/administrator';

export default {
  props: {
    value: {
      type: [String, Number],
      default: '',
    },
    excludeId: {
      type: Number,
      default: 0,
    },
  },
  data: () => ({
    valueBackUp: '',
    list: [],
    error: '',
    isSearching: false,
  }),
  watch: {
    value(value) {
      if (value !== this.valueBackUp) this.valueBackUp = value;
    },
    valueBackUp(valueBackUp) {
      if (valueBackUp !== this.value) this.$emit('input', valueBackUp);
    },
  },
  methods: {
    async handleChange(phone) {
      this.error = '';
      if (phone.length !== 11 || this.isSearching) return;

      this.isSearching = true;
      const { isError, data } = await getIdByPhone({
        phone,
        exclude_id: this.excludeId,
      });
      this.isSearching = false;
      if (isError) return;

      if (data.id) this.error = '该手机号已被使用，请输入其他手机号！';
    }
  },
  beforeMount() {
    this.valueBackUp = this.value;
  },
};
</script>
